export const TYPE_EXECUTION = 1;
export const TYPE_PREPARATION = 2;
export const TYPE_STOPPED = 3;
export const TYPE_ALARM = 4;
export const TYPE_MAINTENANCE = 5;
export const TYPE_PAUSE = 6;
export const TYPE_INACTIVE = 7;

export class ModelTimelineSimple {
  public leftSpace: number;

  constructor(
    public hash?: string,
    public startTime?: number,
    public endTime?: number,
    public eventType?: number
  ) { }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/model-timeline-simple.ts